
export { TransactionErrorContent } from "/home/forge/app.swapkit.network-v2/packages/widgets-internal/swap/TransactionErrorContent.tsx"